import { makeAutoObservable } from 'mobx';

class GravatarStore {
    gravatarUrl = '';

    constructor() {
        makeAutoObservable(this);
    }

    setGravatarUrl(url) {
        this.gravatarUrl = url;
    }

    getGravatarUrl() {
        return this.gravatarUrl;
    }
}

export const gravatarStore = new GravatarStore(); 